import React, { Component } from 'react'
import { connect } from 'react-redux'
import Plx from 'react-plx';

//import T from '../../../translate/T'
import Footer from './../../../../src/SPRINTA/Footer';
import { Container, ContainerFluid, Row, Col } from './../../../../src/SPRINTA/atoms/Grid';
import CoverImage from './../../../../src/SPRINTA/atoms/CoverImage';
import ContactForm from '../../Components/ContactForm'
import './../effects.css';

import style from './style.css'

const balao1 = [
  {
    start: 700,
    duration: 400,
    properties: [
      {
        startValue: 800,
        endValue: 0,
        property: "translateY"
      },
      {
        startValue: 1,
        endValue: 1,
        property: "opacity"
      }
    ]
  }
];
const balao2 = [
  {
    start: 800,
    duration: 500,
    properties: [
      {
        startValue: 800,
        endValue: 0,
        property: "translateY"
      },
      {
        startValue: 1,
        endValue: 1,
        property: "opacity"
      }
    ]
  }
];
const balao3 = [
  {
    start: 900,
    duration: 600,
    properties: [
      {
        startValue: 800,
        endValue: 0,
        property: "translateY"
      },
      {
        startValue: 1,
        endValue: 1,
        property: "opacity"
      }
    ]
  }
];
const balao4 = [
  {
    start: 900,
    duration: 700,
    properties: [
      {
        startValue: 800,
        endValue: 0,
        property: "translateY"
      },
      {
        startValue: 1,
        endValue: 1,
        property: "opacity"
      }
    ]
  }
];
const balao5 = [
  {
    start: 1000,
    duration: 800,
    properties: [
      {
        startValue: 800,
        endValue: 0,
        property: "translateY"
      },
      {
        startValue: 1,
        endValue: 1,
        property: "opacity"
      }
    ]
  }
];
const balao6 = [
  {
    start: 800,
    duration: 900,
    properties: [
      {
        startValue: 800,
        endValue: 0,
        property: "translateY"
      },
      {
        startValue: 1,
        endValue: 1,
        property: "opacity"
      }
    ]
  }
];
const balao7 = [
  {
    start: 1000,
    duration: 1000,
    properties: [
      {
        startValue: 800,
        endValue: 0,
        property: "translateY"
      },
      {
        startValue: 1,
        endValue: 1,
        property: "opacity"
      }
    ]
  }
];
const headerparallax = [
  {
    start: 0,
    duration: 800,
    properties: [
      {
        startValue: 0,
        endValue: 50,
        property: "translateY"
      }
    ]
  }
]

class Desafios extends Component {
  constructor() {
    super();
    this.state = {
       dball1: 'hidden',
       dball2: 'hidden',
       dball3: 'hidden',
       text1: 'hidden',
       text2: 'hidden',
       text3: 'hidden',
       dline1: 'hidden',
       dline2: 'hidden'
    }
  }
  handleScroll() {
    //console.log(document.documentElement.scrollTop);
    var animationBall1 = 'dball1 animated zoomIn'
    var animationBall2 = 'dball2 animated zoomIn'
    var animationBall3 = 'dball3 animated zoomIn'
    var animationtext = 'instdesafiowomanitem animated fadeIn'

    if (document.documentElement.scrollTop > 1200 && this.state.dball1 !== animationBall1){
      this.setState({
        dball1: animationBall1
      })
      setTimeout(function(){
        this.setState({
          text1: animationtext
        })
      }.bind(this), 500);
      setTimeout(function(){
        this.setState({
          dline1: 'dline1 animated fadeIn'
        })
      }.bind(this), 1000);
      setTimeout(function(){
        this.setState({
          dball2: animationBall2
        })
      }.bind(this), 1500);
      setTimeout(function(){
        this.setState({
          text2: animationtext
        })
      }.bind(this), 2000);
      setTimeout(function(){
        this.setState({
          dline2: 'dline2 animated fadeIn'
        })
      }.bind(this), 2500);
      setTimeout(function(){
        this.setState({
          dball3: animationBall3
        })
      }.bind(this), 3000);
      setTimeout(function(){
        this.setState({
          text3: animationtext
        })
      }.bind(this), 3500);
    }
   }
   componentDidMount() {
     window.onscroll = () => this.handleScroll()
   }
  render() {
    return (
      <div>
        <ContainerFluid>
          <Row>
            <Col size="12" style={{paddingLeft: '0',paddingRight: '0'}}>
            <Plx
            className={style.instheader}
              parallaxData={ headerparallax } 
            >
            <CoverImage className={style.instheader} image={require('./background.jpg')}>
            <Container>
              <h1>Desafie-se</h1>
              <p>Só conhecemos nosso limites quando nos desafiamos!<br />Participe ou monte um desafio para a comunidade de atletas</p>
            </Container>
          </CoverImage>
            </Plx>
            </Col>
            <Col size="12" style={{padding:'60px 0'}}>
                <Container>
                  <Row>
                    <Col size="6" className={style.instpublico}>
                      <h1>Incentive a<br/><b>superação de limites</b></h1>
                      <p>Somos naturalmente competitivos, a competição está naturalmente no gene de cada atleta. Somos movidos ao desafio, ao impossível.<br /><br />
                      Crie desafios e incentive milhares de atletas a superarem seus limites diariamente, possibilitando a descoberta de outros eventos no calendário anual, novos caminhos, experiencias e até mesmo, marcas.<br /><br />
                      Crie a relação de cumplicidade entre sua marca e os atletas. 
                      </p>
                    </Col>
                    <Col size="6">
                      <div style={{textAlign:'center'}}>
                        <img alt="" src={require('./cel.png')}/>
                      </div>
                    </Col>
                  </Row>
                </Container>
            </Col>
            <Col size="12" className={style.instdesafiowoman}>
              <Container>
              <div className={style.instdesafiowomanimg}>
                <img src={require('./modelo.png')} alt="" />
              </div>
              <div className={style.instdesafiowomanprl}>
                <Plx parallaxData={ balao1 }>
                  <img src={require('./balao1.png')} alt="" />
                </Plx>
                <Plx parallaxData={ balao2 } className={style.balao2}>
                  <img src={require('./balao2.png')} alt="" />
                </Plx>
                <Plx parallaxData={ balao3 } className={style.balao3}>
                  <img src={require('./balao3.png')} alt="" />
                </Plx>
                <Plx parallaxData={ balao4 } className={style.balao4}>
                  <img src={require('./balao4.png')} alt="" />
                </Plx>
                <Plx parallaxData={ balao5 } className={style.balao5}>
                  <img src={require('./balao5.png')} alt="" />
                </Plx>
                <Plx parallaxData={ balao6 } className={style.balao6}>
                  <img src={require('./balao6.png')} alt="" />
                </Plx>
                <Plx parallaxData={ balao7 } className={style.balao7}>
                  <img src={require('./balao7.png')} alt="" />
                </Plx>
              </div>
                <Row>
                  <Col size="12" style={{textAlign:'right'}}>
                    <div className={style.instdesafiofirst}>
                      <h1><b>Desafio</b>,<br />motivação e<br /><b>recompensa</b></h1>
                      <p className={style.instdesafiofirstp}>Aproxime sua marca dos atletas através de desafios relacionados e oferecendo grandes recompensas.<br /><br />Realize desafios geolocalizados, por sexo, idade, esporte ou mesmo estilo de evento. As possibilidades são infinitas!</p>
                    </div>

                    <Row className={style.instdesafiowomanwrap}>
                      <Col size="12" className={this.state.text1}>
                        <h2><b>Crie</b> um desafio</h2>
                        <p className={style.instdesafiowomanp}>Monte um desafio conforme<br />sua estratégia de marca</p>
                      </Col>
                      <Col size="12" className={this.state.text2}>
                        <h2><b>Divulgue</b> para os atletas</h2>
                        <p className={style.instdesafiowomanp}>Assim que o desafio é criado, todos os atletas da comunidade SPRINTA serão avisados</p>
                      </Col>
                      <Col size="12" className={this.state.text3}>
                        <h2>Confira os <b>resultados</b></h2>
                        <p className={style.instdesafiowomanp}>Confira quais atletas participaram, quem conseguiu realizar o desafio e distribua as recompensas automaticamente</p>
                      </Col>
                      <div className={style.instdesafiotimeline}>
                        <div className={this.state.dball1}></div>
                        <div className={this.state.dline1}></div>
                        <div className={this.state.dball2}></div>
                        <div className={this.state.dline2}></div>
                        <div className={this.state.dball3}></div>
                      </div>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col size="12" className={style.instdesafioscriados}>
              <Container>
                <h1><b>Desafios</b> já criados</h1>
                <Row>
                  <Col size="3" className={style.insdesafiositem}>
                    <div>
                      <img alt="" src={require('./icon1.png')} />
                      <h2><b>Escale</b> 20km de bike</h2>
                      <p>Participe de eventos e acumule 20km de altimetria em um mês. Aos que conseguirem, um uniforme SPRINTA exclusivo</p>
                    </div>
                  </Col>
                  <Col size="3" className={style.insdesafiositem}>
                    <div>
                      <img alt="" src={require('./icon2.png')} />
                      <h2>Participe de <b>3 eventos</b></h2>
                      <p>Durante um mês, participe de 3 eventos de corrida. Aqueles que conseguirem, ganharão 30% OFF em compras na loja SPRINTA</p>
                    </div>
                  </Col>
                  <Col size="3" className={style.insdesafiositem}>
                    <div>
                      <img alt="" src={require('./icon3.png')} />
                      <h2><b>Vença</b> um evento</h2>
                      <p>Vença um evento em 2017! Aos vencedores, bicicletas novas da Trek</p>
                    </div>
                  </Col>
                  <Col size="3" className={style.insdesafiositem}>
                    <div>
                      <img alt="" src={require('./icon4.png')} />
                      <h2>Percorra <b>300km</b></h2>
                      <p>Durante este mês, acumule 300km ou mais em cima da sua bicicleta</p>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
            {/*<Col size="12" className={style.instdesafioscrie}>
              <Container>
                <h1>Converse conosco e <b>crie um<br />desafio</b> da sua marca no SPRINTA</h1>
                <Button inline color="orange">Solicitar contato</Button>
              </Container>
            </Col>*/}
            <Col size="12" className={style.instdesafioscrie}>
              <Container>
                <ContactForm />
              </Container>
            </Col>
          </Row>
        </ContainerFluid>
        <Footer lang="pt-BR" />
      </div>
    )
  }
}

const mapStateToProps = store => ({})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(Desafios)


// WEBPACK FOOTER //
// ./src/App/pages/Desafios/index.js